import React, { useContext } from 'react';
import { Outlet, Link, useLocation, useNavigate } from 'react-router-dom';
import { Users, Building2, Briefcase, FolderOpen, MessageSquare, Calendar, LifeBuoy, FileText, Settings, LogOut, LayoutDashboard, Share2, Shield, Download, Handshake, AlertTriangle, CreditCard, Bell, FileSignature, Activity, FileBarChart, BarChart3, FlaskConical } from 'lucide-react';
import { AuthContext } from '../../App';

const AdminLayout = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { logout } = useContext(AuthContext);

  const handleLogout = () => {
    logout();
    navigate('/auth');
  };

  const isActive = (path) => location.pathname.startsWith(path);

  const menuItems = [
    { path: '/admin', icon: LayoutDashboard, label: 'Dashboard', exact: true },
    { path: '/admin/analytics', icon: BarChart3, label: 'Analytics' },
    { path: '/admin/pilot', icon: FlaskConical, label: 'PILOT Program' },
    { path: '/admin/action-items', icon: AlertTriangle, label: 'Action Items' },
    { path: '/admin/users', icon: Users, label: 'Users' },
    { path: '/admin/companies', icon: Building2, label: 'Companies' },
    { path: '/admin/resources', icon: FolderOpen, label: 'Resources' },
    { path: '/admin/projects', icon: Briefcase, label: 'Projects' },
    { path: '/admin/reservations', icon: Calendar, label: 'Reservations' },
    { path: '/admin/collaborations', icon: Handshake, label: 'Collaborations' },
    { path: '/admin/messages', icon: MessageSquare, label: 'Messaging' },
    { path: '/admin/tickets', icon: LifeBuoy, label: 'Support Tickets' },
    { path: '/admin/commercial', icon: CreditCard, label: 'Commercial' },
    { path: '/admin/contract-usage', icon: FileSignature, label: 'Contracts' },
    { path: '/admin/notification-prefs', icon: Bell, label: 'Notifications' },
    { path: '/admin/user-activity', icon: Activity, label: 'User Actions Log' },
    { path: '/admin/activity-reports', icon: FileBarChart, label: 'Activity Reports' },
    { path: '/admin/exports', icon: Share2, label: 'Exports & Analytics' },
    { path: '/admin/data-export', icon: Download, label: 'Data Export' },
    { path: '/admin/audit-logs', icon: FileText, label: 'Admin Audit Trail' },
    { path: '/admin/password-resets', icon: Shield, label: 'Password Resets' },
    { path: '/admin/settings', icon: Settings, label: 'Settings' }
  ];

  return (
    <div className="min-h-screen bg-gray-100 flex">
      {/* Sidebar */}
      <div className="w-64 bg-white shadow-lg flex flex-col border-r-2 border-emerald-500">
        {/* Logo/Header */}
        <div className="p-6" style={{ backgroundColor: '#1B3240' }}>
          <h1 className="text-2xl font-bold text-white">Admin Panel</h1>
          <p className="text-xs text-gray-300 mt-1">Snow Exchange</p>
        </div>

        {/* Navigation */}
        <nav className="flex-1 p-4 space-y-1">
          {menuItems.map((item) => {
            const Icon = item.icon;
            const active = item.exact 
              ? location.pathname === item.path 
              : isActive(item.path);
            
            return (
              <Link
                key={item.path}
                to={item.path}
                className={`flex items-center space-x-3 px-4 py-3 rounded-lg transition-colors ${
                  active
                    ? 'bg-gradient-to-r from-emerald-500 to-teal-500 text-white font-medium'
                    : 'text-gray-700 hover:bg-gray-100'
                }`}
              >
                <Icon className="w-5 h-5" />
                <span>{item.label}</span>
              </Link>
            );
          })}
        </nav>

        {/* Logout */}
        <div className="p-4 border-t">
          <button
            onClick={handleLogout}
            className="flex items-center space-x-3 px-4 py-3 rounded-lg text-red-600 hover:bg-red-50 w-full transition-colors"
          >
            <LogOut className="w-5 h-5" />
            <span>Logout</span>
          </button>
        </div>
      </div>

      {/* Main Content */}
      <div className="flex-1 overflow-auto">
        <Outlet />
      </div>
    </div>
  );
};

export default AdminLayout;